import { render } from "./BSkeleton.vue?vue&type=template&id=d9c9e3e0&ts=true"
import script from "./BSkeleton.vue?vue&type=script&lang=ts"
export * from "./BSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__